// extracted by mini-css-extract-plugin
export default {"wrapper":"NotAuthorized_wrapper__mdVvp"};